import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import cx from 'classnames';

const recipientName = recipient => {
  return recipient.name || recipient.email;
};

class RecipientItem extends React.Component {
  static propTypes = {
    recipient: PropTypes.object.isRequired,
    onSelected: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onSelected = this.onSelected.bind(this);
  }

  onSelected() {
    this.props.onSelected(this.props.recipient.id);
  }

  render() {
    const { recipient } = this.props;
    const segmentClass = cx('ui segment', {
      active: recipient.isSelected,
    });

    return (
      <div className="four wide column">
        <div className={segmentClass} onClick={this.onSelected}>
          <i className="check circle icon" />
          {recipientName(recipient)}
        </div>
      </div>
    );
  }
}

export default pure(RecipientItem);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/RecipientItem.js